import querystring from "query-string";
import { Epic, ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { catchError, exhaustMap, switchMap } from "rxjs/operators";
import { toChannelsPath } from "../../../libs/channels/utils/channels";
import { RootState } from "../../reducers";
import { PageActions } from "../actions";
import {
    PageNavigateTo,
    PageSetDistributionCodeAction,
    PageValidateChannelsAction,
} from "../actions/default";
import { PAGE_NAVIGATE_TO, PAGE_VALIDATE_CHANNELS } from "../constants";
import { ChannelApi } from "./../../../api/channel-api";

export const pageNavigateToEpic: Epic<PageActions, PageActions, RootState> = (
    action$,
    state$
) =>
    action$.pipe(
        ofType<PageActions, PageNavigateTo>(PAGE_NAVIGATE_TO),
        exhaustMap((action) => {
            const { history, channels, query } = state$.value.page;
            const { channel, partnerType } = channels;
            const channelPath = toChannelsPath(
                action.payload,
                channel,
                partnerType
            );
            history.push({
                pathname: channelPath,
                search: querystring.stringify(query),
            });
            return EMPTY;
        })
    );

export const pageValidateChannelsEpic: Epic<
    PageActions,
    PageActions,
    RootState
> = (action$, state$) =>
    action$.pipe(
        ofType<PageActions, PageValidateChannelsAction>(PAGE_VALIDATE_CHANNELS),
        exhaustMap(() => {
            const { channels } = state$.value.page;
            const { channel } = channels;
            if (!channel) {
                return EMPTY;
            }
            return ChannelApi.getChannel(channel).pipe(
                switchMap(({ data }) => {
                    const distributionCode = data.find(
                        (value: { property: string; value: string }) =>
                            value.property === "distributionCode"
                    );

                    return of(
                        new PageSetDistributionCodeAction(
                            distributionCode.value
                        ).create()
                    );
                }),
                catchError(() => {
                    const { protocol, host } = window.location;
                    const { PUBLIC_URL } = process.env;
                    window.location.href = `${protocol}//${host}${PUBLIC_URL}`;
                    return EMPTY;
                })
            );
        })
    );
